<script>
    import { editorState } from "@app/store/editorStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
    import { commitHistory } from "@app/store/historyStore.svelte.js";
    import { snapSelectedEndsToNext } from "@app/lib/snapEvents.js";
    import { toast } from "@zerodevx/svelte-toast";
    import * as m from '@app/paraglide/messages.js';

    let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0 || isSelectedEventGroupLocked());

    function snapToEnd() {
        try {
            if (isSelectedEventGroupLocked()) {
                toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
                return;
            }

            const egIdx = projectState.selected;
            const eventGroup = eventGroupState[egIdx];
            if (!eventGroup?.selected?.length) {
                return;
            }

            const selected = [...eventGroup.selected];
            const gapSec = editorState.minFrameGap / projectState.frameRate;
            const preview = eventGroup.events.map((event) => ({
                start: event.start,
                end: event.end,
            }));

            if (!snapSelectedEndsToNext(preview, selected, gapSec)) {
                return;
            }

            commitHistory({
                name: "snap to end",
                eventGroup: egIdx,
                mutate: {
                    eventGroupState: (draft) => {
                        snapSelectedEndsToNext(
                            draft[egIdx].events,
                            selected,
                            gapSec,
                        );
                    },
                },
            });
        } catch (err) {
            console.log(err);
            console.log(err.message);
        }
    }
</script>

<li class="nav-item" title={m.snap_to_end_title()}>
    <a
        id="snap-to-end-btn"
        class="nav-link"
        href="#!/"
        class:disabled={isDisabled}
        aria-disabled={isDisabled}
        aria-label={m.snap_to_end_aria_label()}
        role="button"
        onclick={snapToEnd}><i class="bi bi-align-end" aria-hidden="true"></i></a
    >
</li>
